/*@ngInject*/
const FieldReferencesRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getFieldReferences = function (fieldTemplateId) {

        var url = '/rest/UIFormTemplate/findReferencesByFieldTemplateId',
            config = {
                params: {
                    fieldTemplateId: fieldTemplateId
                }
            };

        return this.get(url, config);
    };
};

angular.module('ums.configuration')
    .service('fieldReferencesRepository', FieldReferencesRepository);
